import { Query } from '../../_base/actionBus/Query';
import { Document } from '../../models/documents/Document';
import { Nullable } from '../../_base/lang/Nullable';

export class GetDocuments extends Query<Document[]> {
    constructor(public parentId: Nullable<number> = null) {
        super();
    }
}
